import script from "./ImpostazioniEc.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpostazioniEc.vue?vue&type=script&setup=true&lang=js"

import "./ImpostazioniEc.vue?vue&type=style&index=0&id=4c444a30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c444a30"]])

export default __exports__